import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "show", "hide"]

  show() {
    this.listTarget.classList.remove("hidden")
    this.showTarget.classList.add("hidden")
    this.hideTarget.classList.remove("hidden")
  }

  hide() {
    this.listTarget.classList.add("hidden")
    this.showTarget.classList.remove("hidden")
    this.hideTarget.classList.add("hidden")
  }
}
